import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import ToolTip from '@material-ui/core/Tooltip';
import DateInput from 'components/form/DateInput';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 10,
  }
}));

const Deadline = ({ type, deadlines, canReportDeadline, onSubmit }) => {
  const classes = useStyles();
  const [suggestedDate, setSuggestedDate] = React.useState(null);

  return (
    <Box marginBottom={2}>
      <Typography className={classes.title} variant="caption">{type}</Typography>
      {deadlines.map(i => (
        <Box display="flex" justifyContent="space-between" key={i.id}>
          <Typography variant="small">{i.admission_type}</Typography>
          <Typography variant="small" color={i.flagged ? 'error' : 'textPrimary'}>
            <ToolTip
              title={
                i.suggested_date &&
                `Suggested: ${moment(i.suggested_date).format('L')}`
              }
            >
              <span>{moment(i.deadline).format('L')}</span>
            </ToolTip>{' '}
            {canReportDeadline && (
              <PopupState variant="popover" popupId={`reportDate-${i.id}`}>
                {(popupState) => (
                  <>
                    <a style={{ cursor: 'pointer' }} {...bindTrigger(popupState)}>
                      Report
                    </a>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                    >
                      <Box padding={2}>
                        <Typography variant="body2" gutterBottom>
                          Suggested date:
                        </Typography>
                        <DateInput
                          disablePast
                          autoOk
                          inputVariant="outlined"
                          value={suggestedDate}
                          onChange={setSuggestedDate}
                          placeholder="Select date"
                        />
                        <Box marginTop={2} textAlign="right">
                          <Button
                            variant="text"
                            color="secondary"
                            onClick={popupState.close}
                          >
                            Cancel
                          </Button>{' '}
                          <Button
                            variant="text"
                            color="primary"
                            onClick={onSubmit(i, suggestedDate, popupState)}
                          >
                            Confirm
                          </Button>
                        </Box>
                      </Box>
                    </Popover>
                  </>
                )}
              </PopupState>
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Deadline;
